import { Box, Typography } from "@material-ui/core";

import karstenIcon from "../../../../assets/img/logos/karsten3.png";
import trussardiIcon from "../../../../assets/img/logos/trussardi.png";
import karstenDecorIcon from "../../../../assets/img/logos/karstenDecorDark.png";

const BRANDS = [
  {
    id: "karsten",
    name: "karsten",
    icon: karstenIcon,
    color: "#005870",
    subtitle: "Cama, Mesa e Banho",
  },
  {
    id: "trussardi",
    name: "trussardi",
    icon: trussardiIcon,
    color: "#B7A99A",
    subtitle: "Alta Costura",
  },
  {
    id: "karsten_decor",
    name: "karsten_decor",
    icon: karstenDecorIcon,
    color: "#374151",
    subtitle: "Decoração e Design",
  },
];

export default function IntroBrandScreen({ onSelectBrand, brandKeysWithProducts = new Set() }) {
  const hasProducts = (brandId) => {
    if (!brandKeysWithProducts || typeof brandKeysWithProducts.has !== "function") return true;
    return brandKeysWithProducts.has(brandId);
  };

  const allDisabled = BRANDS.every((brand) => !hasProducts(brand.id));

  return (
    <Box
      className="intro-brand-screen"
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "#fff",
        zIndex: 1300,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
      }}
    >
      <Box style={{ textAlign: "center", marginBottom: 48 }}>
        <Typography
          component="h1"
          className="brand-font"
          style={{
            fontSize: "2.25rem",
            fontWeight: 700,
            color: "#111827",
            marginBottom: 8,
            fontFamily: "'Alexandria', sans-serif",
            letterSpacing: "-0.025em",
          }}
        >
          Portal do Lojista
        </Typography>
        <Typography style={{ color: "#6B7280", fontSize: "1rem" }}>
          Selecione a marca para iniciar o pedido
        </Typography>
      </Box>
      <Box className="intro-brand-grid">
        {BRANDS.map((brand) => {
          const active = hasProducts(brand.id);
          return (
            <Box
              key={brand.id}
              className={`intro-brand-card ${!active ? "intro-brand-card--disabled" : ""}`}
              onClick={active ? () => onSelectBrand(brand.name) : undefined}
              role="button"
              tabIndex={active ? 0 : -1}
              onKeyDown={
                active
                  ? (e) => {
                      if ((e.key === "Enter" || e.key === " ") && onSelectBrand) {
                        e.preventDefault();
                        onSelectBrand(brand.name);
                      }
                    }
                  : undefined
              }
              style={{
                transition: "all 0.3s ease",
                cursor: active ? "pointer" : "not-allowed",
                backgroundColor: active ? "#F9FAFB" : "#F3F4F6",
                border: "1px solid #E5E7EB",
                borderRadius: 12,
                padding: 32,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                aspectRatio: "4/3",
                opacity: active ? 1 : 0.6,
              }}
              onMouseEnter={
                active
                  ? (e) => {
                      e.currentTarget.style.transform = "translateY(-5px)";
                      e.currentTarget.style.boxShadow =
                        "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)";
                      e.currentTarget.style.borderColor = brand.color;
                    }
                  : undefined
              }
              onMouseLeave={
                active
                  ? (e) => {
                      e.currentTarget.style.transform = "translateY(0)";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.borderColor = "#E5E7EB";
                    }
                  : undefined
              }
            >
              <Typography
                component="h2"
                style={{
                  fontSize: "1.875rem",
                  fontWeight: 700,
                  color: brand.color,
                  marginBottom: 8,
                  fontFamily: brand.fontFamily,
                }}
              >
                <img src={brand.icon} alt={brand.name} style={{ width: 150, height: 80, objectFit: "contain" }} />
              </Typography>
              <Typography
                style={{ fontSize: "0.875rem", color: "#6B7280" }}
                className="intro-brand-subtitle"
              >
                {brand.subtitle}
              </Typography>
              {!active && (
                <Typography
                  style={{
                    fontSize: "0.75rem",
                    color: "#9CA3AF",
                    marginTop: 8,
                    fontWeight: 600,
                  }}
                >
                  Sem vitrines disponíveis.
                </Typography>
              )}
            </Box>
          );
        })}
      </Box>
      {allDisabled && (
        <Typography
          style={{
            marginTop: 32,
            color: "#6B7280",
            fontSize: "1.125rem",
            textAlign: "center",
          }}
        >
          Você não possui nenhuma vitrine ativa no momento.
        </Typography>
      )}
    </Box>
  );
}
